module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAgVBMVEUAAAA3SGg1RWowQGA3SGg4SGk4SGg2SWs4SGg4SWk3SGg4SGg4SGg3SWk2SWkAgP8AgP8AgP84SGgZZ7wAgP84SGg3SWkAgf8Agf83SWkAgP8YZ74AgP84SGgAgP8nWZY4SWkAgf8vUYA0THEDfPUHeewKdeMVa8YYaL0jXaEqV47RMf6YAAAAIHRSTlMA0DAQ8KBg9CDgsJ+AcFAQ79/f2M+/r6CQj2BKQEAwLj9G4CAAAACjSURBVDjL7ZDHGoMgEAZFwBpjei//avr7P2CM2XiBoHedC3sYPtjxBvpMtE2PXTxfAQjaPTmDzqD8VlFASE9DRS2eRiyrI/noLkb8qBRYurwAGH+nc4jUsXCzbr64lcgcYTSPa6K7NRL/K+FxQxUPhP7/MDU7qnkijKxhFHsHYl581QxTc5oQcymwMkT1C5NPqeFawvhmDDt7o42AhWLuDfSON6vWEnZtJ30QAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./packages/theme-chalk/src/images/icon-up-arrow@2x.png
// module id = 81
// module chunks = 0